import React, { useEffect, useState } from "react";
import PillButton from "./button/Pills";
import { useParams } from "react-router-dom";
import usersApi from "../services/users/UserApi";
import CommonHeader from "./CommonHeader";
import ToastNotification, { showToast } from "./Toaster";

const ConfigPage = () => {
  const { id } = useParams<{ id: string }>();
  const [config, setConfig] = useState<any>();

  useEffect(() => {
    const fetchUserConfig = async () => {
      try {
        const response = await usersApi.getUserConfig(Number(id));
        if (response.success) {
          setConfig({
            ...response.value.data,
          });
          console.log("response.value L ", response.value);
        } else {
          console.error("Failed to fetch user config:", response.error.message);
        }
      } catch (error) {
        console.error("Error fetching user config:", error);
      }
    };

    if (id) {
      fetchUserConfig();
    }
  }, [id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setConfig((prevConfig: any) => ({
      ...prevConfig,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSave = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Configuration saved: " + JSON.stringify(config, null, 2));
    try {
      const response = await usersApi.setUserConfig({ ...config, userId: id });
      if (response.success) {
        showToast("Configuration saved successfully!", "success");
      } else {
        console.error("Failed to save user config:", response.error.message);
      }
    } catch (error) {
      console.error("Error saving user config:", error);
    }
  };

  return (
    <div className="flex h-[calc(100vh-67px)]">
      <ToastNotification />
      <div className="flex-1">
        <CommonHeader title="User Configuration" />
        <main className="mx-4 sm:mx-10 md:mx-20 lg:mx-40 xl:mx-60 my-10 p-4 sm:p-6 md:p-8 shadow dark:bg-gray-700 dark:text-gray-100 bg-gray-50 rounded-lg">
          <form onSubmit={handleSave} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-100">
                  Group Members Size
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="groupMembersSize"
                  value={config?.groupMembersSize}
                  onChange={handleChange}
                  className="mt-1 block w-full dark:bg-gray-800 border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-100">
                  Max SMS Length
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxSmsLength"
                  value={config?.maxSmsLength}
                  onChange={handleChange}
                  className="mt-1 block w-full dark:bg-gray-800 border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-100">
                  Max MMS Length
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxMmsLength"
                  value={config?.maxMmsLength}
                  onChange={handleChange}
                  className="mt-1 block w-full dark:bg-gray-800 border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-100">
                  Max Contacts
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxContacts"
                  value={config?.maxContacts}
                  onChange={handleChange}
                  className="mt-1 block w-full dark:bg-gray-800 border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-100">
                  Max Groups
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxGroups"
                  value={config?.maxGroups}
                  onChange={handleChange}
                  className="mt-1 block w-full dark:bg-gray-800 border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-100">
                  Max Messages Per Day
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxMessagesPerDay"
                  value={config?.maxMessagesPerDay}
                  onChange={handleChange}
                  className="mt-1 block w-full dark:bg-gray-800 border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-100">
                  Max Campaigns
                </label>
                <input
                  type="number"
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  min={0}
                  name="maxCampaigns"
                  value={config?.maxCampaigns}
                  onChange={handleChange}
                  className="mt-1 block w-full dark:bg-gray-800 border-gray-300 rounded-md"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="smsEnabled"
                  checked={config?.smsEnabled}
                  onChange={handleChange}
                  className="mr-2"
                />
                <label className="text-sm font-medium text-gray-700 dark:text-gray-100">
                  SMS Enabled
                </label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="mmsEnabled"
                  checked={config?.mmsEnabled}
                  onChange={handleChange}
                  className="mr-2"
                />
                <label className="text-sm font-medium text-gray-700 dark:text-gray-100">
                  MMS Enabled
                </label>
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="recurringCampaignsEnabled"
                  checked={config?.recurringCampaignsEnabled}
                  onChange={handleChange}
                  className="mr-2"
                />
                <label className="text-sm font-medium text-gray-700 dark:text-gray-100">
                  Recurring Campaigns Enabled
                </label>
              </div>
            </div>
            <div className="flex justify-center pt-2">
              <PillButton type="submit" variant="dark">
                Update
              </PillButton>
            </div>
          </form>
        </main>
      </div>
    </div>
  );
};

export default ConfigPage;
